<div class="main_content">
    <div #page_section class="page_main_sec">
        <div class="dashboard_main_sec">
            <div class="">
                <div class="post-nav-wrap">
                    <div class="title-wrap">
                        <p class="title">Dashboard</p>
                    </div>
                    <div class="work-item-btn-wrp">
                        <a *ngFor="let worklist of lstWorkListFilter" class="work-item-btn"
                            [class.active]="selectedWorklistId==worklist.worklist_id"
                            (click)="onSelectFilterWorkList(worklist.worklist_id)">
                            {{worklist.worklist_text}} <span
                                class="work-item-count">{{getWorklistCountByDoctype(worklist.documents)}}</span></a>
                        <!-- <a *ngIf="approvalQueryCount>0" routerLink="/work-item" class="work-item-btn">Approval/Queries
                          <span class="work-item-count">{{approvalQueryCount}}</span>
                      </a> -->
                    </div>
                    <div *ngif="totalidea>0" class="title-wrap">
                        <p> Total Idea :
                            <span> {{totalidea}}</span>
                        </p>
                    </div>
                    &nbsp; &nbsp; &nbsp; &nbsp;
                    <div *ngif="maxideageneratedby>0" class="title-wrap">
                        <p class="title"> My Idea Count :
                            {{maxideageneratedby}}</p>
                    </div>

                    <div class="search-box top-search" *ngIf="isDisplaySearchBox">
                        <img src="../../../assets/img/search.png" alt="Search">
                        <input type="search" [(ngModel)]="searchURN" (search)="clearSearch()" autocomplete="off"
                            class="search-input" placeholder="URN">
                        <span class="search-button search-data" (click)="getSearchTransaction()"><i
                                class="material-icons">search</i></span>
                    </div>
                    <ul class="nav top-actions">
                        <li>
                            <a (click)="onIconSearchClick()" class="search-icon pointerCursor" title="Search">
                                <!-- <img src="../../../assets/img/search.png"> -->

                                <i class="material-icons theme-text-color">search</i>
                            </a>
                        </li>
                        <li>
                            <a (click)="showFilterModel();" class="pointerCursor" title="Filter">
                                <!-- <img src="../../../assets/img/filter.png" > -->
                                <i class="material-icons theme-text-color">filter_list</i>
                            </a>
                        </li>
                        <!-- <li>
                          <a (click)="viewType='TABULAR'" [class.active]="viewType=='TABULAR'">
                              <img src="../../../assets/img/table.png" alt="Table view" />
                          </a>
                      </li> -->
                        <!-- <li>
                          <a (click)="viewType='TILE'" [class.active]="viewType=='TILE'">
                              <img src="../../../assets/img/grid.png" alt="Grid View" />
                          </a>
                      </li> -->
                        <li>
                            <a (click)="flipProcess=!flipProcess;selectedRowIndex=-1;selectedCellIndex=-1;"
                                title="{{flipProcess?'Process > Document Type':'Document Type > Process'}}"
                                class="pointerCursor">
                                <i class="material-icons theme-text-color">sync</i>
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/home']" title="Home">
                                <i class="material-icons theme-text-color">home</i>
                            </a>
                        </li>
                    </ul>
                </div>

                <!-- URN Search grid -->
                <div *ngIf="isDisplaySearchGrid">
                    <app-advance-gridview [lstData]="lstTransaction_search" [lstHeaders]="lstHeader_search"
                        [gridTitle]="'Search result for URN '+searchURN" [showColumnGroup]="true"
                        [showAdvanceSearchOption]="false" [showExcelDownloadOption]="false"
                        identityColumnName="DOCUMENT_DETAIL_ID" (cellClickEvent)="cellClickEvent($event)"
                        (columnsFilterChangeEvent)="columnsFilterChangeEvent($event)"></app-advance-gridview>
                </div>

                <div *ngIf="lstProcessData==undefined || lstProcessData.length ==0">
                    <div class="row col s12">
                        <span style="text-align: center;padding-top: 10px;">No record found.</span>
                    </div>

                </div>
                <!-- Process & Document Type list & txn count -->
                <div class="tab-content">
                    <div>
                        <div *ngIf="viewType=='TABULAR'">
                            <div class="table_header_sec">
                                <!-- <h4 class="page_inner_title">Queue & Work Item Type wise Invoice count</h4> -->
                                <div class="page_search_main_sec">
                                    <div class="page_search_expand">
                                        <div class="p_urn_sec">
                                            <img src="/assets/img/arrow-bar-right.svg" class="mr-2" alt="URN">
                                            <span>URN</span>
                                        </div>
                                        <div class="urn_input_sec">
                                            <input type="text" class="p_urn_search" value="BSR_20210708_402">
                                            <img src="/assets/img/cancel-icon.png" alt="Cancel"
                                                class="p_urn_cancel_icon">
                                        </div>
                                        <div class="urn_search_btn_sec">
                                            <img src="/assets/img/search_quick.svg" class="mr-2" alt="Search">
                                            <span>Search</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="lstProcessQueue.length>0" class="table scroll_table mrb10">
                                <div #processData class="outer_table mrr-10">
                                    <div class="scrollable_other_tables ">
                                        <div class="tableHeaderWrp" #countStickyTable>
                                            <table *ngIf="!flipProcess" class="sticky" id="left_header">
                                                <tbody>
                                                    <tr class="stickytr">
                                                        <th class="custom_width">
                                                            Queue</th>
                                                    </tr>
                                                    <tr *ngFor="let process of lstProcessQueue;let rowIndex=index">
                                                        <td class="custom_width"
                                                            [class.highlight-header-cell]="rowIndex==selectedRowIndex">
                                                            {{process.processName}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <table *ngIf="flipProcess" class="sticky" id="left_header">
                                                <tbody>
                                                    <tr class="stickytr">
                                                        <th class="custom_width">
                                                            Work Item Type</th>
                                                    </tr>
                                                    <tr *ngFor="let doc of lstDocumentQueue;let rowIndex=index">
                                                        <td class="custom_width"
                                                            [class.highlight-header-cell]="rowIndex==selectedRowIndex">
                                                            {{doc.documentName}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div #scrollableGrid class="scroll_animation">
                                            <div class="count_grid innner_scroll"
                                                [style.max-width]="'calc(100vw - ' + (countStickyTable.offsetWidth + 40) + 'px)'">
                                                <div class="scroll_tables first_table">
                                                    <table *ngIf="!flipProcess" class="other_tables"
                                                        [style.min-width]="'calc(100vw - ' + (countStickyTable.offsetWidth + 40) + 'px)'">
                                                        <thead>
                                                            <tr>
                                                                <th *ngFor="let doc of lstProcessQueue[0].documentList;let cellIndex=index"
                                                                    class="custom_width text-center"
                                                                    [class.highlight-header-cell]="cellIndex==selectedCellIndex">
                                                                    {{doc.documentName}}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr
                                                                *ngFor="let process of lstProcessQueue;let rowIndex=index">
                                                                <td *ngFor="let doc of process.documentList;let cellIndex=index"
                                                                    class="text-center pointerCursorIcon"
                                                                    [class.highlight-target-cell]="rowIndex==selectedRowIndex && cellIndex==selectedCellIndex"
                                                                    (click)="selectedRowIndex=rowIndex;selectedCellIndex=cellIndex;onTransactionSummaryGridCellClick(doc,process);">
                                                                    <span
                                                                        [class.txn-count-doctype]="doc.count>0">{{doc.count}}</span>
                                                                    <span #selectedCountTd
                                                                        *ngIf="doc.documentId==activeDocument && process.processId==activeProcess">
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <table *ngIf="flipProcess && lstDocumentQueue.length>0"
                                                        class="other_tables"
                                                        [style.min-width]="'calc(100vw - ' + (countStickyTable.offsetWidth + 40) + 'px)'">
                                                        <thead>
                                                            <tr>
                                                                <th *ngFor="let process of lstDocumentQueue[0].processList;let cellIndex=index"
                                                                    class="custom_width text-center"
                                                                    [class.highlight-header-cell]="cellIndex==selectedCellIndex">
                                                                    {{process.processName}}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr *ngFor="let doc of lstDocumentQueue;let rowIndex=index">
                                                                <td class="text-center pointerCursorIcon"
                                                                    *ngFor="let process of doc.processList;let cellIndex=index"
                                                                    [class.highlight-target-cell]="rowIndex==selectedRowIndex && cellIndex==selectedCellIndex"
                                                                    (click)="selectedRowIndex=rowIndex;selectedCellIndex=cellIndex;getSummaryData(doc,process)">
                                                                    <span
                                                                        [class.txn-count-doctype]="process.count>0">{{process.count}}</span>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <!-- Tile View: (Process > Document Type)-->
                        <div *ngIf="viewType=='TILE' && !flipProcess" class="row stats-bx-wrap">
                            <ng-container *ngFor="let process of lstProcessQueue;let bxIndex=index">
                                <div *ngIf="bxIndex < 6" [class.stats-active]="activeProcess==process.processId"
                                    (click)="loadStatDrop('process',process,$event)" class="stats-bx">
                                    <p class="stat-title" title="{{process.processName}}">
                                        {{process.processName}}
                                    </p>
                                    <span class="stat-count">{{process.count}}</span>
                                    <span class="material-icons drop-icon">arrow_drop_down</span>
                                </div>
                            </ng-container>
                            <div *ngIf="showAllBx" class="collapsible-data flex">
                                <ng-container *ngFor="let process of lstProcessQueue;let bxIndex=index">
                                    <div *ngIf="bxIndex >= 6" [class.stats-active]="activeProcess==process.processId"
                                        (click)="loadStatDrop('process',process,$event)" class="stats-bx">
                                        <p class="stat-title" title="{{process.processName}}">
                                            {{process.processName}}
                                        </p>
                                        <span class="stat-count">{{process.count}}</span>
                                        <span class="material-icons drop-icon">arrow_drop_down</span>
                                    </div>
                                </ng-container>
                            </div>
                            <a *ngIf="viewType=='TILE' && lstProcessQueue.length>6" (click)="showAllBx=!showAllBx"
                                class="view-collapse">
                                <span *ngIf="showAllBx">
                                    <i class="material-icons">arrow_upward</i> View Less
                                </span>
                                <span *ngIf="!showAllBx">
                                    <i class="material-icons">arrow_downward</i> View More
                                </span>
                            </a>
                        </div>

                        <!-- Tile View: (Document Type > Process) -->
                        <div *ngIf="viewType=='TILE' && flipProcess" class="row stats-bx-wrap">

                            <ng-container *ngFor="let doc of lstDocumentQueue;let bxIndex=index">
                                <div *ngIf="bxIndex < 6" [class.stats-active]="activeDocument==doc.documentId"
                                    (click)="loadStatDrop('doc',doc,$event)" class="stats-bx">
                                    <p class="stat-title" title="{{doc.documentName}}">
                                        {{doc.documentName}}
                                    </p>
                                    <span class="stat-count">{{doc.count}}</span>
                                    <span class="material-icons drop-icon">arrow_drop_down</span>
                                </div>
                            </ng-container>
                            <div *ngIf="showAllBx" class="collapsible-data flex">
                                <ng-container *ngFor="let doc of lstDocumentQueue;let bxIndex=index">
                                    <div *ngIf="bxIndex >= 6" [class.stats-active]="activeDocument==doc.documentId"
                                        (click)="loadStatDrop('doc',doc,$event)" class="stats-bx">
                                        <p class="stat-title" title="{{doc.documentName}}">
                                            {{doc.documentName}}
                                        </p>
                                        <span class="stat-count">{{doc.count}}</span>
                                        <span class="material-icons drop-icon">arrow_drop_down</span>

                                    </div>
                                </ng-container>
                            </div>
                            <a *ngIf="viewType=='TILE' && lstDocumentQueue.length>6" (click)="showAllBx=!showAllBx"
                                class="view-collapse">
                                <span *ngIf="showAllBx">
                                    <i class="material-icons">arrow_upward</i> View Less
                                </span>
                                <span *ngIf="!showAllBx">
                                    <i class="material-icons">arrow_downward</i> View More
                                </span>
                            </a>

                        </div>

                    </div>
                </div>

                <div [style.display]="(viewType=='TILE' && showStatDrop)?'block':'none'" class="row">
                    <div #stateDrop class="col s12 stats-drop-wrp">
                        <span class="close-stat" (click)="showStatDrop=false">x</span>
                        <div class="stat-drop">
                            <ng-container>
                                <div class="stat-count-wrp" [class.active]="activeDocument==doc.documentId"
                                    *ngFor="let doc of lstStatDropProcess.documentList;let j=index"
                                    (click)="getSummaryData(doc,lstStatDropProcess)">
                                    <a><span class="drop-count m-bold">{{doc.count}}</span></a>
                                    <span>{{doc.documentName}}</span>
                                </div>

                                <div class="stat-count-wrp" [class.active]="activeProcess==process.processId"
                                    *ngFor="let process of lstStatDropDocument.processList"
                                    (click)="getSummaryData(lstStatDropDocument,process)">
                                    <a><span class="drop-count m-bold">{{process.count}}</span></a>
                                    <span>{{process.processName}}</span>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Transaction summary grid -->
            <div #summary_grid>
                <div class="" *ngIf="isDisplayTransactionData">
                    <app-advance-gridview [lstData]="lstTransaction" [lstHeaders]="lstHeaders" #gridTransactionData
                        [currentPage]="currentPage" [recordsPerPage]="recordsperPage"
                        [gridTitle]="processName+' | '+selectedDocument" [showColumnGroup]="true"
                        [showAdvanceSearchOption]="true" [advanceSearchFields]="advanceSearchSummaryFields"
                        [isOpenAdvanceSearch]="isOpenAdvanceSearch" [showExcelDownloadOption]="true"
                        identityColumnName="DOCUMENT_DETAIL_ID" (cellClickEvent)="cellClickEvent($event)"
                        (advanceSearchClickEvent)="advanceSearchClickEvent($event)"
                        (columnsFilterChangeEvent)="columnsFilterChangeEvent($event)"
                        (setPaginationLocalStorageEvent)="setPaginationLocalStorageEvent()"
                        [Isserversidepaginationenabled]="pageflag" (downloadalldata)="downloadalldata($event)">
                    </app-advance-gridview>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #filterOptionModal let-modal>
    <div class="modal-content">
        <div class="modal-header model_center_header">
            <h5 class="modal-title">Filter Options</h5>
            <div>
                <button type="button" class="model_ok_btn" (click)="filterProcessData()">Apply</button>
                <button type="button" class="model_cancle_btn" (click)="modal.dismiss('Cross click')">Close</button>
            </div>
        </div>
        <div class="modal-body custom_modal_body">
            <div class="">
                <div class="row">
                    <!-- (click)="$event.stopPropagation();" -->
                    <mat-checkbox class="chk-filter-persona filterCheck" [(ngModel)]="saveAsDefaultFilter">
                        Save as default
                    </mat-checkbox>
                    <div class="col-lg-6">
                        <div>
                            <span class="bx-sub-title">Work Item Type</span>
                            <ul class="selection-list">
                                <!-- <div class="col-lg-6"> -->
                                <li [class.selected]="filteredDoctypes.includes(0)" (click)="onSelectFilterDocument(0)">
                                    <div class="selected-check">All ({{getAllDoctypeCount()}})</div>
                                </li>
                                <!-- </div>
                          <div class="col-lg-6"> -->
                                <li *ngFor="let doc of lstDocumentTypeFilter"
                                    [class.selected]="filteredDoctypes.includes(doc.documentId)"
                                    (click)="onSelectFilterDocument(doc.documentId)">
                                    <div class="selected-check">{{doc.documentName}} ({{doc.count}})</div>
                                </li>
                                <!-- </div> -->
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div>
                            <span class="bx-sub-title">Queue</span>
                            <ul class="selection-list">
                                <li [class.selected]="filteredQueue.includes(0)" (click)="onSelectFilterQueue(0)">
                                    <div class="selected-check">All</div>
                                </li>
                                <li *ngFor="let process of ProcessList"
                                    [class.selected]="filteredQueue.includes(process.process_id)"
                                    (click)="onSelectFilterQueue(process.process_id)">
                                    <div class="selected-check">{{process.process_name}}</div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <hr>
                <div class="row advance-search-wrp">
                    <div *ngIf="frmFilterSearch">
                        <div class="row">
                            <div class="bx-sub-title m-bold">Search</div>
                            <div class="col-lg-3">
                                <mat-form-field appearance="legacy" [style.width.%]="100">
                                    <mat-label for="urn">URN</mat-label><input matInput placeholder="URN"
                                        [(ngModel)]="txtURN" id="urn">
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field appearance="legacy" [style.width.%]="100">
                                    <mat-label for="priority">Priority</mat-label>
                                    <mat-select [(ngModel)]="ddlPriority" id="priority">
                                        <mat-option *ngFor="let option of lstPriority" [value]="option.value">
                                            {{ option.text }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <!-- <div class="col-lg-3">
                              <mat-form-field appearance="legacy" [style.width.%]="100">
                                  <mat-label>Input Type</mat-label><input matInput placeholder="Input Type" [(ngModel)]="txtInputType">
                              </mat-form-field>
                          </div>
                          <div class="col-lg-3">
                              <mat-form-field appearance="legacy" [style.width.%]="100">
                                  <mat-label>Input From</mat-label><input matInput placeholder="Input From" [(ngModel)]="txtInputFrom">
                              </mat-form-field>
                          </div> -->
                            <div class="col-lg-3">
                                <mat-form-field [style.width.%]="100">
                                    <mat-label for="received_date_range">Received Date Range</mat-label>
                                    <mat-date-range-input [min]="commonService.minDate" [rangePicker]="picker"
                                        [formGroup]="invoiceCreationDateRange" id="received_date_range">
                                        <input matStartDate formControlName="start_date" #startdate
                                            placeholder="Start Date" [max]="maxDate"
                                            (dateChange)="onInvoiceCreationDateChanges()">
                                        <input matEndDate formControlName="end_date" #endDate placeholder="End Date"
                                            [max]="maxDate" (dateChange)="onInvoiceCreationDateChanges()">
                                    </mat-date-range-input>
                                    <button *ngIf="isDateRangeHasValue" mat-button matSuffix mat-icon-button
                                        (click)="resetInvoiceCreationDateRange()">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                    <mat-date-range-picker #picker></mat-date-range-picker>
                                </mat-form-field>
                            </div>
                            <!-- <div [formGroup]="frmFilterSearch" *ngFor="let field of advanceSearchFilterFields"
                              [ngSwitch]="field.control_type|lowercase"
                              class="col-lg-{{field.control_type=='TEXTAREA'?6:3}}">

                              <mat-form-field *ngSwitchCase="'textbox'" [style.width.%]="100">

                                  <input matInput *ngIf="field.value_type=='text'" [type]="field.value_type"
                                      [placeholder]="field.field_name" [formControlName]="field.db_column_name" />

                                  <input matInput *ngIf="field.value_type=='number'"
                                      [formControlName]="field.db_column_name" [type]="field.value_type"
                                      [placeholder]="field.field_name" class="text-end"
                                      (change)="onTextChange(field);" />
                                  <button *ngIf="hasValue(field)" mat-button matSuffix mat-icon-button
                                      (click)="clearText(field)">
                                      <mat-icon>clear</mat-icon>
                                  </button>
                                  <button *ngIf="field.is_magnify_search==1" mat-button matSuffix mat-icon-button
                                      (click)="openFilterFieldMagnifySearchModal(field.field_mapping_detail_id,field.magnify_dependant_fields,field.predefined_table_column_name)">
                                      <mat-icon>search</mat-icon>
                                  </button>
                              </mat-form-field>

                              <mat-form-field appearance="legacy" *ngSwitchCase="'dropdown'" [style.width.%]="100">
                                  <mat-label>{{field.field_name}}</mat-label>
                                  <mat-select [formControlName]="field.db_column_name" (click)="searchText.focus()"
                                      (focus)="searchText.focus()" (closed)="searchText.value=''">
                                      <input type="search" (keydown)="$event.stopPropagation()" #searchText autocomplete="off" class="mat-select-search"
                                          placeholder="Search {{field.field_name}}">
                                      <mat-option [value]="option.id"
                                          *ngFor="let option of field.options| listFilter:{'name':searchText.value}">
                                          {{option.name}}
                                      </mat-option>
                                  </mat-select>
                                  <button *ngIf="field.is_magnify_search==1" mat-button matSuffix mat-icon-button
                                      (click)="$event.stopPropagation();openFilterFieldMagnifySearchModal(field.field_mapping_detail_id,field.magnify_dependant_fields,field.predefined_table_column_name)">
                                      <mat-icon>search</mat-icon>
                                  </button>
                              </mat-form-field>

                              <mat-form-field *ngSwitchCase="'date'" [style.width.%]="100">
                                  <input matInput readonly [formControlName]="field.db_column_name"
                                      [matDatepicker]="picker" [placeholder]="field.field_name"
                                      [min]="commonService.minDate">
                                  <button *ngIf="hasValue(field)" mat-button matSuffix mat-icon-button
                                      (click)="clearText(field)">
                                      <mat-icon>clear</mat-icon>
                                  </button>
                                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                  <mat-datepicker #picker></mat-datepicker>
                              </mat-form-field>

                              <mat-form-field *ngSwitchCase="'textarea'" [style.width.%]="100">
                                  <textarea matInput [placeholder]="field.field_name"
                                      [formControlName]="field.db_column_name" rows="1"></textarea>
                              </mat-form-field>
                          </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>